/* eslint-disable camelcase */
export default class ClubItemModel {
  constructor(clubId, price) {
    this.item_id = clubId;
    this.item_name = price > 100 ? 'club membership' : 'top-up';
    this.item_list_id = price > 100 ? 'club' : 'points';
    this.item_list_name = price > 100 ? 'clubs' : 'points';
    this.price = price;
    this.quantity = 1;
  }
}
